<template>
  <el-table
    :data="getTableData"
    border
    style="width: 100%"
    :maxHeight="maxHeight"
  >
    <template slot="empty">
      <empty />
    </template>
    <el-table-column
      prop="payDate"
      label="付款日期"
      width="120"
    ></el-table-column>
    <el-table-column
      prop="buyCount"
      label="购买人数"
      width="100"
      align="right"
    ></el-table-column>
    <el-table-column
      prop="buyAmount"
      label="购买金额"
      width="120"
      align="right"
    >
    </el-table-column>

    <!-- 按月-->
    <template v-if="tableType == 0">
      <el-table-column label="当月" align="center">
        <el-table-column
          prop="month0Count"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="month0Amount"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="month0Ratio"
          label="留存率"
          width="100"
          align="right"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in 12*nowYearNum"
        :key="'m' + i"
        :label="'第' + i + '个月'"
        align="center"
      >
        <el-table-column
          :prop="'month' + i + 'Count'"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'month' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'month' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="right"
        ></el-table-column>
      </el-table-column>
    </template>

    <!-- 按季度 -->
    <template v-if="tableType == 1">
      <el-table-column label="当前季度" align="center">
        <el-table-column
          prop="quarter0Count"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="quarter0Amount"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="quarter0Ratio"
          label="留存率"
          width="100"
          align="right"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in 4*nowYearNum"
        :key="'q' + i"
        :label="'第' + i + '季度'"
        align="center"
      >
        <el-table-column
          :prop="'quarter' + i + 'Count'"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'quarter' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'quarter' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="right"
        ></el-table-column>
      </el-table-column>
    </template>
    <!-- 按年 -->
    <template v-if="tableType == 2">
      <el-table-column label="当前年" align="center">
        <el-table-column
          prop="year0Count"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="year0Amount"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          prop="year0Ratio"
          label="留存率"
          width="80"
          align="right"
        ></el-table-column>
      </el-table-column>
      <el-table-column
        v-for="i in nowYearNum"
        :key="'y' + i"
        :label="'第' + i + '年'"
        align="center"
      >
        <el-table-column
          :prop="'year' + i + 'Count'"
          label="留存人数"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'year' + i + 'Amount'"
          label="留存金额"
          width="100"
          align="right"
        ></el-table-column>
        <el-table-column
          :prop="'year' + i + 'Ratio'"
          label="留存率"
          width="100"
          align="right"
        ></el-table-column>
      </el-table-column>
    </template>
  </el-table>
</template>

<script>
import Empty from "../../components/empty.vue";
import mixins from "../../mixins";
export default {
  name: "retentionRateAnalysis",
  mixins: [mixins],
  components: {
    Empty,
  },
  props: {
    tableData: {
      type: Array,
      default: () => [],
    },
    maxHeight: {
      type: [Number, String],
      default: 500,
    },
    reportParams: {
      type: Object,
      default: () => {},
    },
  },
  computed: {
    getTableData() {
      const isMonth = this.tableType == 0;
      let tableList = this.tableData.map((item) => {
        const row = {
          payDate: item.payDate,
          buyCount: item.buyCount,
          buyAmount: item.buyAmount,
        };
        if (item.retentionVOList && item.retentionVOList.length > 0) {
          item.retentionVOList.forEach((subItem) => {
            const prefix = isMonth ? "month" : this.tableType == 1 ? "quarter" : 'year';
            row[`${prefix}${subItem.index}Count`] = subItem.repurchaseCount;
            row[`${prefix}${subItem.index}Amount`] = subItem.repurchaseAmount;
            row[`${prefix}${subItem.index}Ratio`] = subItem.repurchaseRatio;
          });
        }
        return row;
      });
      tableList = tableList.map((row) => {
        const newRow = {};
        Object.keys(row).forEach((key) => {
          // 不需要处理得字段直接返回
          if (key === "payDate") {
            newRow[key] = row[key];
            return;
          }
          // Ratio 字段 → 百分比
          if (key.includes("Ratio")) {
            newRow[key] = this.formatPercent(row[key]);
          } else {
            // 其他数值 → 普通数字
            newRow[key] = this.formatNumber(row[key]);
          }
        });
        return newRow;
      });
      return tableList;
    },
    tableType() {
      return this.reportParams.dimension || 0;
    },
    nowYearNum() {
      return this.reportParams.retentionPeriod || 1;
    },
  },
};
</script>
